import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";


export const formulaPayableItemFields = `
id
itemUniqueId
itemName
itemBaseCost
itemMinimumCount
itemIncrimentalValue
itemIncrimentalUnitPrice
`


export const CREATE_FORMULA_PAYABLE_ITEM = gql`
  mutation CreateFormularPayableItem($input: FormularPayableItemInputObjects!) {
    createFormularPayableItem(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${formulaPayableItemFields}
      }
    }
  }
`


export const UPDATE_FORMULA_PAYABLE_ITEM = gql`
  mutation UpdateFormularPayableItem($input: FormularPayableItemInputObjects!) {
    updateFormularPayableItem(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${formulaPayableItemFields}
      }
    }
  }
`

export const DELETE_FORMULA_PAYABLE_ITEM = gql`
  mutation DeleteFormularPayableItem($itemUniqueId: String!) {
    deleteFormularPayableItem(itemUniqueId: $itemUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`

export const GET_FORMULA_PAYABLE_ITEM = gql`
query GetInstitutionServiceFormulaPayableItems($formularUniqueId: String) {
  getInstitutionServiceFormulaPayableItems(formularUniqueId: $formularUniqueId) {
    ${baseResponseGraphqlField}
    data {
      ${formulaPayableItemFields}
    }
  }
}
`
// Modified
export const CITIZEN_GET_INSTITUTION_SERVICE_FORMULAR_PAYABLE_ITEM = gql`
  query CitizenGetInstitutionServiceFormulaPayableItems($formularUniqueId: String) {
    citizenGetInstitutionServiceFormulaPayableItems(formularUniqueId: $formularUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        ${formulaPayableItemFields}
      }
    }
  }
`;